<script setup>
import { defineProps } from 'vue'
import DocSection from '@/components/Docs/Section.vue'
import JsonBlock from '@/components/Docs/JsonBlock.vue'

defineProps({ anchor: String })
</script>

<template>
  <doc-section title="Response format" :anchor="anchor">
    <template v-slot:left>
      <p>
        Responses are distinguished by their HTTP status code. All successful
        requests return a <code>200</code> with a JSON envelope containing a
        <code>status</code> field and a <code>data</code> field; some endpoints add
        an <code>errors</code> array for per-item soft failures. The
        <code>data</code> field holds the requested information.
      </p>
      <p>
        If the input is malformed or invalid, a <code>400 Bad Request</code> is
        returned. Accessing an authenticated endpoint with a missing, invalid, or
        inactive key returns <code>401 Not Authorized</code>. Requesting an endpoint
        or dataset your account is not granted returns <code>403 Forbidden</code>.
        Exceeding your usage quota returns <code>429 Too Many Requests</code>.
      </p>
      <p>
        File-download endpoints (event and enrichment exports) are the exception, 
        they stream an attachment rather than a JSON envelope.
      </p>
    </template>

    <template v-slot:right>
      <json-block title="Standard response" :statuscode="200">
        {
          "status": "success",
          "data": {},
          "errors": []
        }
      </json-block>
      <json-block :raw="true" title="Invalid input" :statuscode="400">
        Bad Request
      </json-block>
      <json-block :raw="true" title="Invalid API key" :statuscode="401">
        Not Authorized
      </json-block>
      <json-block :raw="true" title="Usage quota exceeded" :statuscode="429">
        Too many requests
      </json-block>
    </template>
  </doc-section>
</template>
